<template>
  <div id="app">
      <img
        style="max-width: 100%; height: 100%; position: fixed; top: 0; left: 0; pointer-events: none; user-select: none;"
        src="../assets/media/NewBannerLogin.png"
      />
    <div class="app flex-row align-items-center">
      <div class="container">
        <b-row class="justify-content-end">
          <b-col md="6">
            <div v-if="Loading==true">
              <div class="d-flex justify-content-center">
                <h1>Log Masuk</h1>
              </div>
              <br />
              <div class="d-flex justify-content-center">
                <PulseLoader float />
              </div>
            </div>
            <div v-else>
              <h1 style="text-align:center" class="mb-5">MyEduloan</h1>
              <b-card-group>
                <b-card no-body>
                  <b-card-body>
                    <b-form>
                      <h1 style="text-align:center">Log Masuk</h1>
                      <p class="text-muted" style="text-align:center">Log Masuk ke akaun anda</p>
                      <b-input-group class="mb-3">
                        <b-input-group-prepend>
                          <b-input-group-text>
                            <i class="icon-user"></i>
                          </b-input-group-text>
                        </b-input-group-prepend>
                        <b-form-input
                          type="text"
                          class="form-control"
                          placeholder="No. Kad Pengenalan"
                          autocomplete="username"
                          v-model="username"
                        />
                      </b-input-group>
                      <b-input-group class="mb-4">
                        <b-input-group-prepend>
                          <b-input-group-text>
                            <i class="icon-lock"></i>
                          </b-input-group-text>
                        </b-input-group-prepend>
                        <b-form-input
                          type="password"
                          class="form-control"
                          placeholder="Kata Laluan"
                          autocomplete="current-password"
                          v-model="password"
                        />
                      </b-input-group>
                      <b-row>
                        <b-col cols="6">
                          <b-button variant="primary" class="px-4" v-on:click="trylogin">Log Masuk</b-button>
                        </b-col>
                        <b-col cols="6" class="text-right">
                          <b-button
                            variant="link"
                            class="px-0"
                            :href="publicPath + '#/ForgotPassword'"
                          >Lupa kata laluan?</b-button>
                        </b-col>
                      </b-row>
                      <hr />
                      <div style="text-align:center">
                        <b-button
                          variant="primary"
                          class="active mt-3 btn-block"
                          :href="publicPath + '#/SignUp'"
                        >Daftar Sekarang!</b-button>
                      </div>
                    </b-form>
                  </b-card-body>
                </b-card>
              </b-card-group>
            </div>
            <div v-if="this.Error===true">
              <b-alert show variant="warning">{{ Message }}</b-alert>
            </div>
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import PulseLoader from "vue-spinner/src/PulseLoader.vue";

export default {
  name: "Login",
  e1: "#app",
  components: {
    PulseLoader
  },
  data: function() {
    return {
      image: "@/assets/media/BannerLogin.png",
      publicPath: process.env.BASE_URL,
      username: "",
      password: "",
      Loading: false,
      Error: false,
      LoadingMyIdentity: false,
      Message: "",
      sCFN: "Login: ",
    };
  },
  methods: {
    async trylogin() {
      let fN = 'trylogin: ';
      this.Error = false;
      this.Loading = true;
      const formData = new FormData();
      if (this.username === "" || this.password === "") {
        this.Loading = false;
        this.Error = true;
        this.Message = "Sila lengkapkan ID / kata laluan.";
      } else {
        formData.append("identityno", this.username);
        formData.append("password", this.password);
        this.$API
          .post(this.$SignIn, formData, { withCredentials: true })
          .then(response => {
            if (response.data.status === 500) {
              this.HTECHLogger(this.sCFN + fN + 'Status = 500')
              this.Loading = false;
              this.Message = response.data.detail;
              this.Error = true;
            }
            if (response.status == 202) {
              this.HTECHLogger(this.sCFN + fN + 'Status = 202')
              this.$store.dispatch("user/updateUserIdentity", this.username);
              this.$store.dispatch("user/updateIsAuthenticated", true);
              this.$store.dispatch("user/updateUserCategory", 0);
              this.$router.push("/Home");
            } else {
              this.tryloginInstitutePIC();
              this.$store.dispatch("user/updateIsAuthenticated", false);
              this.Loading = false;
              this.Error = true;
              this.Message = response.data.detail;
            }
          })
          .catch((error) => {
            this.Message = error.response.data.detail;
            let result = error.response.data.detail.includes("Anda telah gagal log masuk lebih dari 3 kali berturut-turut.");
            if (true === result) {
              this.Message = error.response.data.detail;
              this.$store.dispatch("user/updateIsAuthenticated", false);
              console.log(error);
              this.Loading = false;
              this.Error = true;
              this.Message = error.response.data.detail;
            } else
              this.tryloginInstitutePIC();
          });
      }
    },
    async tryloginInstitutePIC() {
      let fN = 'tryloginInstitutePIC: ';
      this.Error = false;
      this.Loading = true;
      const formData = new FormData();
      if (this.username === "" || this.password === "") {
        this.Loading = false;
        this.Error = true;
        this.Message = "Sila lengkapkan ID / kata laluan.";
      } else {
        formData.append("identityno", this.username);
        formData.append("password", this.password);
        return this.$API
          .post(this.$SignInInstitutePIC, formData, { withCredentials: true })
          .then((response) => {
            if (response.status === 500) {
              this.HTECHLogger(this.sCFN + fN + 'Status = 500')
              this.Loading = false;
              this.Message = response.data.detail;
              this.Error = true;
            }
            if (response.status == 202) {
              this.HTECHLogger(this.sCFN + fN + 'Status = 202')
              this.$store.dispatch("user/updateUserIdentity", this.username);
              this.$store.dispatch("user/updateIsAuthenticated", true);
              this.$store.dispatch("user/updateUserCategory", 2);
              this.$router.push("/Home");
              //this.$router.push("/HomeInstitutePIC");
              //this.$router.push({ name: 'Permohonan', params: { usercategory: 'institute_pic' } })
            } else {
              this.$store.dispatch("user/updateIsAuthenticated", false);
              this.Loading = false;
              this.Error = true;
              this.Message = response.data.detail;
            }
          })
          .catch((error) => {
            let result = error.response.data.detail.includes("Anda telah gagal log masuk lebih dari 3 kali berturut-turut.");
            if (true === result) { this.Message = error.response.data.detail; }
            this.$store.dispatch("user/updateIsAuthenticated", false);
            console.log(error);
            this.Loading = false;
            this.Error = true;
            this.Message = error.response.data.detail;
          });
      }
    }
  }
};
</script>
